import { Col } from "antd";
import styled from "styled-components";

export const CarouselSlick = styled(Col)`
  height: 5px;
  flex: 0 0 auto;
  background-color: #1890ff;
`;
